import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InputRadio from 'modules/_shared/components/InputRadio';
import presetRecipients from 'constants/presetRecipients';
import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';
import { RecipientSourceOption } from '../types/RecipientSourceOption';
import { recipientSources } from '../constants/recipientSources';
import PartnerSourceView from './PartnerSourceView';
import RecipientsList from './RecipientsList';

const RecipientsSection: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useSendCommunicationModal();

  const handleToggleRecipientSource = (value: string) => {
    actions.handleChangeRecipientSource(value);
  };

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <h6 className="title mb-0 mr-1">{t('Recipients')}</h6>
        <span
          className={`badge badge-pill ${
            data.recipientsCount > 0 ? 'badge-primary' : 'badge-gray'
          }`}
        >
          {data.recipientsCount || 0}
        </span>
      </div>

      {!data.hasDefaultRecipient && (
        <div className="row mb-3">
          {recipientSources.map((source: RecipientSourceOption) => (
            <div
              key={source.id}
              className="col-6 col-md-4 col-lg-auto custom-control custom-control-sm custom-radio custom-control-pro p-0"
            >
              <InputRadio
                id={`recipient-source-${source.id}`}
                checked={data.recipientSource === source.value}
                label={t(source.label)}
                onChange={() => handleToggleRecipientSource(source.value)}
                disabled={source.disabled}
              />
            </div>
          ))}
        </div>
      )}

      {data.recipientSource === presetRecipients.PARTNERS && (
        <PartnerSourceView />
      )}

      <RecipientsList />
    </div>
  );
};

export default RecipientsSection;
